import React from 'react';
import PaymentDetailContainer from '../../../Componant/Ecommerce/PaymentDetail';

const PaymentDetail = () => {
  return (
    <div className='page-body'>
      <PaymentDetailContainer />
    </div>
  );
};

export default PaymentDetail;
